import { Loader } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { PractitionerMatch } from '@common/interfaces/practitionerMatchType';
import { MatchingPractitionerTableSelector } from '@frontend/components/elements/MatchingPractitionerTableSelector';
import { getSelectedLanguage } from '@frontend/translate';
import { useAccountRequestContext } from '@frontend/utils/hooks/useAccountRequestContext';

export function SelectMatchingPractitionerTable() {
    const {
        isLoading: isLoadingAccountRequest,
        fetchMatchingPractitioners,
        setSelectedMatch,
    } = useAccountRequestContext();

    const [isInitialized, setIsInitialized] = useState<boolean>(false);
    const [matchingPractitioners, setMatchingPractitioners] = useState<PractitionerMatch[]>([]);

    const language = getSelectedLanguage();

    useEffect(() => {
        if (!isLoadingAccountRequest && !isInitialized) {
            const fetchData = async () => {
                const nextMatchingPractitioners = await fetchMatchingPractitioners();

                setMatchingPractitioners(nextMatchingPractitioners);

                setIsInitialized(true);
            };

            fetchData();
        }
    }, [isLoadingAccountRequest, isInitialized]);

    return (
        <>
            {!isInitialized ? (
                <Loader size="medium" />
            ) : (
                <MatchingPractitionerTableSelector
                    alertTextWithMatches={{
                        description: language.accountRequest.reviewByKsyos.alertWithMatches.description,
                        title: language.accountRequest.reviewByKsyos.alertWithMatches.title,
                    }}
                    alertTextWithoutMatches={{
                        title: language.accountRequest.reviewByKsyos.alertWithoutMatches.title,
                    }}
                    onSelectMatch={setSelectedMatch}
                    practitionerMatches={matchingPractitioners}
                />
            )}
        </>
    );
}
